export default __webpack_public_path__ + "static/media/Franchise_type_img.0e9ff8a5.jpg";